import React from 'react'
import { Grid } from '@mui/material'
import useStyles from './Style'
import clsx from 'clsx'
import ImgCard from './imgCard/ImgCard'
interface IProps {
  zenMode: boolean
  content: {
    img: string
    name: string
    designation: string
    description: string
  }[]
}
const PhotoGallery: React.FC<IProps> = ({ zenMode, content }) => {
  const { classes } = useStyles()
  let activeIndex = 1
  return (
    <Grid className={classes.rootContainer}>
      <Grid
        container
        sx={{
          '& img': {
            display: zenMode ? 'none' : 'inline',
          },
        }}
        spacing={4}
      >
        {content.map((curr, index) => {
          if (index > activeIndex) {
            activeIndex += 3
          }
          if (index == activeIndex) {
            return (
              <Grid
                key={index}
                item
                md={4}
                sm={6}
                xs={12}
                className={clsx(
                  classes.imgGrid,
                  classes.midImgGrid,
                  zenMode && classes.zenMidImgGrid
                )}
              >
                <ImgCard content={curr} zenMode={zenMode} />
              </Grid>
            )
          } else {
            return (
              <Grid
                key={index}
                item
                md={4}
                sm={6}
                xs={12}
                className={classes.imgGrid}
              >
                <ImgCard content={curr} zenMode={zenMode} />
              </Grid>
            )
          }
        })}
      </Grid>
    </Grid>
  )
}

export default PhotoGallery
